// -- AUTOGENERATED --

// eslint-disable-next-line no-unused-vars
import APIUtils from '@/util/apiutil'

import Axios from 'axios'
import NETVSConfig from '@/../netvs.config'

/* eslint-disable camelcase */
/* eslint-disable quote-props */
/* eslint-disable object-curly-spacing */
/* eslint-disable array-bracket-spacing */
/* eslint-disable object-shorthand */
export default {

  createParamsList () {
    return {'old': [ ], 'new': [ 'name', 'next_gpk', 'prior_gpk', 'short_name', 'pos_to_last', 'pos_to_first']}
  },
  create (config, {name_new, next_gpk_new, prior_gpk_new, short_name_new, pos_to_last_new, pos_to_first_new}) {
    const params = { 'new': { 'name': name_new, 'next_gpk': next_gpk_new, 'prior_gpk': prior_gpk_new, 'short_name': short_name_new, 'pos_to_last': pos_to_last_new, 'pos_to_first': pos_to_first_new}, 'old': { }}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit_type/create`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  deleteParamsList () {
    return {'old': [ 'short_name'], 'new': [ ]}
  },
  delete (config, {short_name_old}) {
    const params = { 'new': { }, 'old': { 'short_name': short_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit_type/delete`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  list (config, { gpk_list, fetch_limit, fetch_offset, short_name_list, filter_params_dict, sorting_params_list }) {
    const params = APIUtils.denullify_dict({ 'gpk_list': (gpk_list === null) ? null : JSON.stringify(gpk_list), 'fetch_limit': fetch_limit, 'fetch_offset': fetch_offset, 'short_name_list': (short_name_list === null) ? null : JSON.stringify(short_name_list), 'filter_params_dict': filter_params_dict, 'sorting_params_list': (sorting_params_list === null) ? null : JSON.stringify(sorting_params_list)})
    const cnf = {}
    Object.assign(cnf, (config || {}).netdb_axios_config)
    cnf.params = params
    return Axios.get(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit_type/list`, cnf)
  // eslint-disable-next-line comma-dangle
  },
  updateParamsList () {
    return {'old': [ 'short_name'], 'new': [ 'name', 'next_gpk', 'prior_gpk', 'short_name', 'pos_to_last', 'pos_to_first']}
  },
  update (config, {name_new, next_gpk_new, prior_gpk_new, short_name_old, short_name_new, pos_to_last_new, pos_to_first_new}) {
    const params = { 'new': { 'name': name_new, 'next_gpk': next_gpk_new, 'prior_gpk': prior_gpk_new, 'short_name': short_name_new, 'pos_to_last': pos_to_last_new, 'pos_to_first': pos_to_first_new}, 'old': { 'short_name': short_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit_type/update`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
}
